import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {ToolsService} from '../../../../../../services/tools.service';
import {CareproviderUnitService} from '../../../../../../services/careprovider-unit.service';
import {CpruTabsService} from '../../../../../../services/cpru-tabs.service';
import {RoutesAddonsEnums} from '../../../../../../enums/RoutesEnums';
import {WindowSizeService} from '../../../../../../services/window-size.service';

@Component({
  selector: 'app-cpru-top-info-desc-section',
  templateUrl: './cpru-top-info-desc-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block w-full lg:grow-1 m-w-full order-2 lg:order-1',
  },
})
export class CpruTopInfoDescSectionComponent {
  private cpruTabsService = inject(CpruTabsService);
  private careproviderUnitService = inject(CareproviderUnitService);
  protected careproviderUnit = this.careproviderUnitService.careproviderUnit;
  protected shortDesctiption = computed<string>(() =>
    this.tools.shortenHtmlDescription(this.careproviderUnit().description, 400),
  );
  private windowSize = inject(WindowSizeService);
  private size = this.windowSize.windowSize;
  private readonly mobileTabsThreshold = 992;
  protected isMobile = computed<boolean>(() => this.size()[0] < this.mobileTabsThreshold);

  constructor(private tools: ToolsService) {}

  public scrollToAboutSection(): void {
    this.cpruTabsService.changeTabAndScrollToSection(RoutesAddonsEnums.CAREPROVIDER_ABOUT);
  }
}
